export type ScenarioMatrix = number[][]; // [scenarioIndex][yearIndex]

export interface ScenarioDataMap {
  usEquity: ScenarioMatrix;
  internationalEquity: ScenarioMatrix;
  bonds: ScenarioMatrix;
  cash: ScenarioMatrix;
  inflation: ScenarioMatrix;
}

let cachedScenarioData: Promise<ScenarioDataMap> | null = null;

async function fetchBin(path: string): Promise<ArrayBuffer> {
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${path}: ${response.status} ${response.statusText}`);
  }
  return await response.arrayBuffer();
}

function parseBinToMatrix(buffer: ArrayBuffer, rows = 5000, cols = 35): ScenarioMatrix {
  const floats = new Float32Array(buffer);
  const expected = rows * cols;
  if (floats.length !== expected) {
    throw new Error(`Unexpected float count: ${floats.length} (expected ${expected})`);
  }
  const matrix: number[][] = new Array(rows);
  for (let r = 0; r < rows; r++) {
    const row: number[] = new Array(cols);
    for (let c = 0; c < cols; c++) {
      row[c] = floats[r * cols + c];
    }
    matrix[r] = row;
  }
  return matrix;
}

export async function loadScenarioData(): Promise<ScenarioDataMap> {
  if (!cachedScenarioData) {
    cachedScenarioData = (async () => {
      const base = '/data';
      const [usEq, intlEq, bonds, cash, infl] = await Promise.all([
        fetchBin(`${base}/us-equity.bin`),
        fetchBin(`${base}/international-equity.bin`),
        fetchBin(`${base}/bonds.bin`),
        fetchBin(`${base}/cash.bin`),
        fetchBin(`${base}/inflation.bin`),
      ]);

      const scenarioData: ScenarioDataMap = {
        usEquity: parseBinToMatrix(usEq),
        internationalEquity: parseBinToMatrix(intlEq),
        bonds: parseBinToMatrix(bonds),
        cash: parseBinToMatrix(cash),
        inflation: parseBinToMatrix(infl),
      };

      return scenarioData;
    })();
  }
  return cachedScenarioData;
}


